module.exports = __webpack_public_path__ + "static/media/small-fail-cross-square.c459a7c8.svg";